import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

export const adminApi = axios.create({ baseURL: `${API}/api`, withCredentials: true });

export const apiError = (e, fallback = "Algo deu errado. Tente novamente.") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};

export const MODALITY_LABEL = { online: "Online", presencial: "Presencial" };
export const PAYMENT_LABEL = { pix: "Pix", cartao: "Cartão de crédito ou débito", whatsapp: "A combinar pelo WhatsApp" };
